import {
  CHANGE_ACTIVE_ROUTE
} from './SideBarConstants';

export const changeRoute = (payload) => {
  return {
    type: CHANGE_ACTIVE_ROUTE,
    payload,
  }
}